import React, { Suspense } from "react";
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux'; // Creates the Central Redux Store
import { Provider } from 'react-redux'; // Makes sure the Store is connected to React
import App from './App.js';
import reducer from './reducers'; // Gets the root reducer to be used by the store
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import './i18n';
//import {configureFakeBackend} from './helpers/fake-backend.js';
//configureFakeBackend();

const Loader = () => <div>loading...</div>;


//hook up the redux devtools browser extension
const store = createStore(reducer,
  composeWithDevTools (
    applyMiddleware(thunk)
  )
);

render(
  <Provider store={store}>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
  </Provider>,
  document.getElementById('root')
);
